module.exports = __webpack_public_path__ + "img/receipt-white.13e338ce.png";